import { css } from "styled-components"
import { colors } from "../../../helpers/colors"
import { fonts } from "../../../helpers/fonts"

export const MenuOverlayStyles = css``
export const MenuWrapperStyles = css`
  background: ${colors.dark};
`
export const LogoWrapperStyles = css``
export const MenuItemsStyles = css`
  font-size: ${fonts.sizes[2]};
`
export const MenuLinkStyles = css`
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.blue};
  }
`
export const SubmenuLinkStyles = css``
export const ButtonsWrapperStyles = css``
